const RSU_BASE_URL = '/rsu/';
const RSU_FILE_UPLOAD_SUCCESS = "RSU_FILE_UPLOAD_SUCCESS";
const RSU_FILE_UPLOAD_FAILURE = "RSU_FILE_UPLOAD_FAILURE";
const RSU_FINAL_STATUSES = "downloadfailed,downloadcancelled,downloadpaused,installfailed,installsucceeded,installscheduled,installcancelled";
const RSU_MNFST_FILE_NAME = "manifest";
const RSU_STATUS_DWNLD_SUCCD = "downloadsucceeded"; 
const RSU_STATUS_DWNLD_STARTED = "downloadstarted"; 
const RSU_REPO_MODAL_CONTROL = "RSU_REPO_MODAL_CONTROL";
const RSU_GET_REPO_FILES_INFO_REQUEST = "RSU_GET_REPO_FILES_INFO_REQUEST";
const RSU_GET_REPO_FILES_INFO_SUCCESS = "RSU_GET_REPO_FILES_INFO_SUCCESS";
const RSU_GET_REPO_FILES_INFO_FAILURE = "RSU_GET_REPO_FILES_INFO_FAILURE";
const FILE_TYPE_RSU = "RSU";
const RSU_RESET_ERRORS = "RSU_RESET_ERRORS";
const EXCEPTION = "exception";
const RSU_STATUS_DWNLD_FAIL = "downloadfailed";
const RSU_STATUS_INSTL_FAIL = "installfailed";
const RSU_DEVICE_STATE_ADD = 'RSU_DEVICE_STATE_ADD';
const RSU_DEVICE_STATE_REMOVE = 'RSU_DEVICE_STATE_REMOVE';

export {
    RSU_BASE_URL,
    RSU_FILE_UPLOAD_SUCCESS,
    RSU_FILE_UPLOAD_FAILURE,
    RSU_FINAL_STATUSES,
    RSU_MNFST_FILE_NAME,
    RSU_STATUS_DWNLD_SUCCD,
    RSU_REPO_MODAL_CONTROL,
    RSU_GET_REPO_FILES_INFO_REQUEST,
    RSU_GET_REPO_FILES_INFO_SUCCESS,
    RSU_GET_REPO_FILES_INFO_FAILURE,
    FILE_TYPE_RSU,
    RSU_RESET_ERRORS,
    EXCEPTION,
    RSU_STATUS_DWNLD_FAIL,
    RSU_STATUS_INSTL_FAIL,
    RSU_DEVICE_STATE_ADD,
    RSU_DEVICE_STATE_REMOVE,
    RSU_STATUS_DWNLD_STARTED
}